import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import queryString from 'query-string';

export const hasLocationSupport = WrappedComponent =>
  class HasLocationSupport extends Component {
    updateLocation(options) {
      browserHistory.push(options);
    }

    generatePathWith(params, isWithPathName = true) {
      const location = browserHistory.getCurrentLocation();
      let query = {};
      Object.keys(params).map((key) => {
        query = queryString
          .stringify(Object.assign(location.query, { [key]: params[key] }));
      });

      if (!isWithPathName) {
        return `?${query}`;
      }

      return `${location.pathname}?${query}`;
    }

    updateLocationForGlobalSearch(queryParam, pathName = null) {
      this.updateLocation({
        pathname: `${pathName || '/search'}`,
        search: `?query_param=${queryParam}`,
      });
    }

    render() {
      return (<WrappedComponent
        generatePathWith={this.generatePathWith}
        updateLocation={this.updateLocation}
        updateLocationForGlobalSearch={this.updateLocationForGlobalSearch}
        {...this.props}/>);
    }
  };



// WEBPACK FOOTER //
// ./src/Common/HOC/LocationSupport.js